import React, { useState } from "react";
import { Button, Input, Select } from "antd";
import { getDataWithEndpoint, request } from "../../../functions/request";
import {
  formatDateHourToBR,
  updateData,
} from "../../../functions/functionsUtility";
import { DescriptionsLayout } from "../../../layout";
import { FaSave } from "react-icons/fa";

const estados = [
  { value: "SP", label: "São Paulo" },
  { value: "GO", label: "Goiás" },
  { value: "MT", label: "Mato Grosso" },
  { value: "MS", label: "Mato Grosso do Sul" },
  { value: "MG", label: "Minas Gerais" },
  { value: "PR", label: "Paraná" },
  { value: "RS", label: "Rio Grande do Sul" },
];

const cotacoesLabel = [
  { value: "verde_av", label: "Verde (A/V)" },
  { value: "verde_30", label: "Verde (30d)" },
  { value: "salg", label: "Salgado" },
  { value: "salg_prazo", label: "Prazo Salgado" },
];

export default function InterboisCouro() {
  const [cotacoesData, setCotacoesData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const aux = Object.entries(cotacoesData).map(([key, value], index) => {
    if (key !== "boi_data" && key !== "boi_uf") {
      const cotLabel = cotacoesLabel.find((label) => label.value === key);
      return {
        label: cotLabel ? cotLabel.label : key,
        children: (
          <Input
            className="input-number"
            value={value}
            disabled={isLoading}
            onChange={(event) => {
              const inputValue = event.target.value;
              const formattedValue = inputValue;
              const newData = {
                ...cotacoesData,
                [key]: formattedValue,
              };
              setCotacoesData(newData);
            }}
          />
        ),
        span: 2,
      };
    }
  });

  const items = [
    {
      label: "Estado",
      children: (
        <Select
          showSearch
          style={{ width: "100%" }}
          optionFilterProp="children"
          placeholder="Selecione um estado"
          filterOption={(input, option) =>
            (option?.label ?? "").includes(input)
          }
          filterSort={(optionA, optionB) =>
            (optionA?.label ?? "")
              .toLowerCase()
              .localeCompare((optionB?.label ?? "").toLowerCase())
          }
          options={estados}
          loading={isLoading}
          onChange={(value) => {
            setIsLoading(true);
            setCotacoesData([]);
            getDataWithEndpoint(
              "boi_couro",
              `getBoiCourobyuf?uf=${encodeURIComponent(value)}`
            )
              .then((res) => {
                setCotacoesData(res);
              })
              .finally(() => {
                setIsLoading(false);
              });
          }}
          allowClear={true}
        />
      ),
      span: 3,
    },
    {
      label: "Última Alteração",
      children: formatDateHourToBR(cotacoesData.boi_data),
      span: 3,
    },
  ];

  return (
    <>
      <DescriptionsLayout
        title={"Interbois - Couro"}
        items={[...items, ...aux.filter(Boolean)]}
        extra={
          <div style={{ padding: 10, display: "flex", gap: 10 }}>
            <Button
              type="primary"
              size="large"
              htmlType="submit"
              icon={<FaSave />}
              disabled={isLoading}
              onClick={async () => {
                updateData({
                  ...cotacoesData,
                  endpoint: "updateBoiCouro",
                  path: "boi_couro",
                });
              }}
            >
              Atualizar
            </Button>
          </div>
        }
      />
    </>
  );
}
